"use strict";

const upscoreRecommenderId = 'upscore_recommender';
document.addEventListener('BaseDataLoaded', () => {
  const upscoreRecommenderElement = document.getElementById(upscoreRecommenderId);
  const maxItems = window.getSettingsFromApi('upscore_recommender_max_items') || 4;
  const recoKey = window.getSettingsFromApi('upscore_reco_key');
  if (!upscoreRecommenderElement) {
    console.warn(`[UpScore] element '#${upscoreRecommenderId}' not found on page`);
  }
  if (!recoKey) {
    console.warn('[UpScore] The `reco_key` not configured in api settings (`fapi/settings`)');
  }
  if (upscoreRecommenderElement && recoKey) {
    window._uprec({
      config: {
        reco_key: recoKey,
        tag: '',
        target_selector: `#${upscoreRecommenderId}`,
        max_items: maxItems,
        template_selector: {
          item_free: '#article-template',
          wrapper: '#template-wrapper'
        }
      }
    });
    window._uprec({
      data: {
        object_id: upscoreRecommenderElement.dataset.articleId,
        user_status: window.getUpScoreUserStatus()
      }
    });
  }
});